import Long from 'long';

export default function fromUnixStamp(stamp?: Long | null): number {
  return (stamp?.toNumber() || 0) * 1000;
}